import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from '../services/auth-service.service';
import { Observable } from 'rxjs/Observable';
import { Router} from '@angular/router';
import 'rxjs/add/operator/do';
import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //skipping custom headers to avoid CORS on beat health check end points
    if (request.url.indexOf(environment.S1Url) >= 0
      || request.url.indexOf(environment.fezeUrl) >= 0
      || request.url.indexOf(environment.natRepUrl) >= 0
      || request.url.indexOf(environment.supplierUrl) >= 0)
      request = request.clone({setHeaders: {Authorization: `Bearer ${this.auth.Token}`}});
    else
      request = request.clone();

    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) { }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.auth.logout();
          this.router.navigateByUrl("/login");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/token.interceptor.ts